import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, forwardRef, memo } from 'react';
import classnames from 'classnames';
import CSSTransition from 'react-transition-group/CSSTransition';
import styled from 'styled-components';
import { transitionFade } from '../theme/mixins';
import { useForkRef } from '../utils/withForwardedRef';
var Root = styled.div.withConfig({
  displayName: "ui-kit-Root",
  componentId: "ui-kit-16t8r5q"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  z-index: -1;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: ", ";\n  -webkit-tap-highlight-color: transparent;\n  touch-action: none;\n\n  ", "\n\n  &.transparent {\n    background-color: transparent;\n  }\n"], ["\n  position: fixed;\n  z-index: -1;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: ", ";\n  -webkit-tap-highlight-color: transparent;\n  touch-action: none;\n\n  ", "\n\n  &.transparent {\n    background-color: transparent;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.background.neutral.dialogOverlay;
}, transitionFade());
var Backdrop = forwardRef(function (_a, ref) {
  var open = _a.open,
      TransitionProps = _a.TransitionProps,
      invisible = _a.invisible,
      className = _a.className,
      otherProps = __rest(_a, ["open", "TransitionProps", "invisible", "className"]);

  var rootClassName = classnames(className, {
    transparent: invisible
  });
  var nodeRef = useRef();
  var handleRef = useForkRef(ref, nodeRef);
  return _jsx(CSSTransition, __assign({
    in: open,
    classNames: "fade",
    timeout: 300
  }, TransitionProps, {
    nodeRef: nodeRef
  }, {
    children: _jsx(Root, __assign({}, otherProps, {
      className: rootClassName,
      ref: handleRef
    }))
  }));
});
export default memo(Backdrop);
var templateObject_1;